import { Avatar, useTheme } from '@material-ui/core'
import React from 'react'

// Helper function to create initials safely
const createInitials = (firstName, lastName) => {
	const first = firstName || ''
	const last = lastName || ''
	
	const firstInitial = first.charAt(0).toUpperCase()
	const lastInitial = last.charAt(0).toUpperCase()
	
	// If both names exist, return both initials
	if (firstInitial && lastInitial) {
		return firstInitial + lastInitial
	}
	// If only one name exists, return that initial
	if (firstInitial) {
		return firstInitial
	}
	if (lastInitial) {
		return lastInitial
	}
	// If no names exist, return default
	return 'N/A'
}

export const UserAvatar = ({ firstName, lastName, ...props }) => {
	const theme = useTheme()
	
	const initials = createInitials(firstName, lastName)

	return (
		<Avatar
			style={{
				fontSize: props.fontSize || '.9rem',
				height: props.customHeight,
				width: props.customWidth,
				backgroundColor: theme.palette.primary.main,
			}}
			{...props}
		>
			{initials}
		</Avatar>
	)
}

UserAvatar.defaultProps = {
	firstName: '',
	lastName: '',
}
